import { FooterContact, getFooter } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRegion } from "./RegionProvider";

const TenantFooter = getFooter();

export const Footer: FC = () => {
	const { t } = useTranslation();
	const { region } = useRegion();

	const contact: FooterContact | undefined =
		(region &&
			(region.contactEmail || region.contactPhoneNumber) && {
				label: t("Contact"),
				email: region.contactEmail,
				name: region.contactName || region.contactEmail,
				phone: region.contactPhoneNumber,
			}) ||
		undefined;

	return <TenantFooter footerLinks={region?.footerLinks || []} contact={contact} company={region?.companyName} />;
};
